// extracted by mini-css-extract-plugin
module.exports = {"spinner":"malt-loading-spinner-index-spinner-5213e13c","loader":"malt-loading-spinner-index-loader-0bd10793"};